module.exports = __webpack_public_path__ + "static/media/fat-boy-mobile.5f064cff.png";